import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetch = (institutionId: string) =>
    RESTClient.getAuthenticated('v2/closingdays', {
        institutionId,
        includeBehaviors: true,
    });

export const addClosingDay = (institutionId: string, day: string, reason: string, dayType: number) =>
    RESTClient.postAuthenticated('v2/closingdays', {
        institutionId,
        day,
        reason,
        dayType,
    });

export const deleteClosingDay = (closingDayId: string) =>
    RESTClient.postAuthenticated(`v2/closingdays/${closingDayId}/delete`);

export const deleteClosingDays = (closingDayIds: string[]) =>
    RESTClient.postAuthenticated('v2/closingdays/delete', {
        closingDayIds,
    });
